import { useQuery } from "react-query";
import { IApiGetTagsResponse, TApiGetTagsResponse, Tag } from "./tags.type";
import { sortTagsByDate } from "./tags.utils";
import { propelyApi } from "../../../libs/firebase/api";

type GetTagsOptions = {
  onSuccess?: (data: IApiGetTagsResponse) => void;
  refetchOnMount?: boolean;
  enabled?: boolean;
};

export type GetTagsInput = {
  companyId?: string;
  propertyId?: string | string[];
};

export const useTagsByID = (input: GetTagsInput) => ["tags", { companyId: input.companyId, propertyId: input.propertyId }];

export const useTags = (input: GetTagsInput, options?: GetTagsOptions) => {
  const $tags = useQuery(
    useTagsByID(input),
    async () =>
      propelyApi()
        .get(`/tags`, {
          params: {
            company: input.companyId,
            property: input.propertyId,
          },
          paramsSerializer: { indexes: null },
        })
        .then((response) => {
          return TApiGetTagsResponse.parse(response.data);
        }),
    options && { enabled: options.enabled, refetchOnMount: options.refetchOnMount, onSuccess: options.onSuccess }
  );

  const tags = $tags.data?.datas?.sort(sortTagsByDate);

  return { $tags, tags };
};
